module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second.0fd41d31.png";